import { Injectable } from '@angular/core';

/*
  Generated class for the DataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class DataProvider {
  /** オンラインインジケータ */
  public online: boolean = true;
  /** 店舗ID */
  public shopId: string;
  /** 店舗名 */
  public shopName: string;
  /** 表示中のタブ名 */
  public currentTabName: string;
  /** 会員種別(説明文つき) */
  public memberTypeDesc: any;
  /** オプション */
  public options: Map<string, boolean> = new Map<string, boolean>();
  /** オプション(説明文つき) */
  public optionsDesc: any;
  /** 利用開始日 */
  public startDate: string;
  /** 利用開始月の総日数（日割り計算用） */
  public totalDays: string;
  /** 利用開始日の利用開始月における残日数（日割り計算用） */
  public currentDays: string;
  /** 個人情報：姓 */
  public familyName: string;
  /** 個人情報：名 */
  public givenName: string;
  /** 個人情報：セイ */
  public familyNameKana: string;
  /** 個人情報：メイ */
  public givenNameKana: string;
  /** 個人情報：性別 */
  public sex: string;
  /** 個人情報：生年月日 */
  public birthDay: string;
  /** 個人情報：郵便番号 */
  public zipCode: string;
  /** 個人情報：都道府県 */
  public prefecture: string;
  /** 個人情報：市区町村 */
  public municipality: string;
  /** 個人情報：町字 */
  public section: string;
  /** 個人情報：番地 */
  public address: string;
  /** 個人情報：建物名 */
  public building: string;
  /** 個人情報：電話番号 */
  public tel: string;
  /** 個人情報：メールアドレス */
  public mail: string;
  /** 個人情報：緊急連絡先姓 */
  public ecFamilyName: string;
  /** 個人情報：緊急連絡先名 */
  public ecGivenName: string;
  /** 個人情報：緊急連絡先電話番号 */
  public ecTel: string;
  /** 支払い方法 */
  public paymentType: string;
  /** 顔写真 */
  public photo: string;
  /** サイン(SVG) */
  public sign: string;
  /** カート番号 */
  public id: string;
  public time: string;
  public hash: string;

  constructor() {
    console.log('Hello DataProvider Provider');
  }

}

@Injectable()
export class CardProvider {
  public memberNo: string;
  public lastname: string;
  public name: string;
  public katakanaLastname: string;
  public katakanaName: string;
  public birthDay: any;
  public cardNo: string;
  public email: string;  
  public color: string;
  public logoPic: string;
  public pdfUrl: string;
  public programs: any;
  public startDate: string;
}

@Injectable()
export class PageProvider {
  // ipad entry
  public t01: boolean = false;
  public t02: boolean = false;
  public t03: boolean = false;
  public t04: boolean = false;
  public t05: boolean = false;
  public t06: boolean = false;
  public t07: boolean = false;
  public t08: boolean = false;
  public t09: boolean = false;
  // ipad entry edit
  public ret01: boolean = false;
  public ret02: boolean = false;
  public ret03: boolean = false;
  public ret04: boolean = false;
  public ret05: boolean = false;
  public ret06: boolean = false;
  public ret07: boolean = false;
  public ret08: boolean = false;
  public ret09: boolean = false;
}

/** 体験申込情報 */
@Injectable()
export class PersonalData {
    session: Session = new Session();
    people: Person[] = [];
    enquetes: Enquete[] = [];
    pay: string = '';
}

/** 体験申込情報 */
@Injectable()
export class TrialPersonalData {
    session: TrialSession = new TrialSession();
    people: Person[] = [];
    enquetes: Enquete[] = [];
    pay: string = '';
}

/** セッション */
@Injectable()
export class Session {
    shopId: string = '';
    sessionDate: string = '';
    startTime: string = '';
    programTypeId: string = '';
    programDispName: string = '';
}

/** セッション */
@Injectable()
export class TrialSession {
    shopId: string = '';
    sessionDate: string = '';
    startTime: string = '';
}

/** 個人情報 */
@Injectable()
export class Person {
    name1: string = '';
    name2: string = '';
    kana1: string = '';
    kana2: string = '';
    dateOfBirth: string = '';
    gender: string = '';
    email: string = '';
    tel1: string = '';
    tel2: string = '';
    tel3: string = '';
    zip1: string = '';
    zip2: string = '';
    addr1: string = '';
    addr2: string = '';
    addr3: string = '';
    addr4: string = '';
    addr5: string = '';
    e1Name1: string = '';
    e1Name2: string = '';
    e1Tel1: string = '';
    e1Tel2: string = '';
    e1Tel3: string = '';
    shopId: string = '';
}

/** 複数人の個人情報 */
@Injectable()
export class People {
    people: Person[] = [];
}

/** 1つのアンケート内容 */
@Injectable()
export class Enquete {
    qId: string = '';
    ans: string = '';
    ver: string = '';
}

/** 全てのアンケート入力内容 */
@Injectable()
export class Enquetes {
    enquetes: Enquete[] = [];
}

/** EMS予約画面で用いる内部パラメータ */
@Injectable()
export class ReserveSession {

  /**
   * 以下のパラメータは Cookie で管理するため、定義不要
   */
  // auth_key: string = '';
  // member_no: string = '';
  // last_login: string = '';

  /** 店舗ID */
  shop_id: string = '';
  /** 店舗名 */
  shopName: string = '';
  /** セッション日 */
  session_date: string = '';
  /** 開始時間 */
  start_time: string = '';
  /** メールアドレス */
  mail_addr: string = '';
  /** キャンセル待ち人数 */
  reservation_cancel_waiting: string = '';
  /** 予約可能かどうか */
  can_reservation: boolean = true;
  /** 今月の利用回数 */
  monthlyUsedCount: string = '';
  /** 今月の残利用回数 */
  monthlyRestCount: string = '';
  /** プログラムタイプID */
  program_kind: string = '';
  /** プログラム表示名 */
  program_type_id: string = '';
  program_disp_name: string = '';
  /** プログラム価格 */
  program_price: string = '';
  /**  */
  notice: string = '';
  /**  */
  private_setting_flag: string = '';
}
@Injectable()
export class Reservation {
  /** 店舗ID */
  shop_id: string = '';
  /** 店舗名 */
  shop_name: string = '';
  /** セッション日 */
  session_date: string = '';
  /** 開始時間 */
  start_time: string = '';
  /** 予約ステータス */
  reservation_status = '';
  /** キャンセル待ち人数 */
  reservation_cancel_waiting: string = '';
  /** プログラム表示名 */
  program_disp_name: string = '';
}
@Injectable()
export class HistorySelCond {
/** 店舗ID */
shop_id: string = '';
/** 店舗名 */
shop_name: string = '';
}
@Injectable()
export class YearMonth {
  /** 年 */
year: string = '';
 /** 月 */
month: string = '';
}
@Injectable()
export class ClassOfProcess {
/** 値 */
　value: string = '';
　/** 文字 */
　text: string = '';
　/** 区分 */
classes: string = '';
}
@Injectable()
export class HistorySelect {
  /** 日付 */
  used_date: string = '';
  /** 区分 */
  classes: string = '';
  /** 内容 */
  content: string = '';
   /** 年月 */
　year_month: string = '';
  /** 店舗ID */
  shop_id: string = '';
}



// WEBPACK FOOTER //
// ./src/providers/data/data.ts